<template>
  <a-modal
    :visible="visible"
    :width="660"
    centered
    :footer="null"
    @cancel="$emit('cancel')"
  >
    <template #title>
      <div class="flex items-end">
        <img 
          src="@/assets/images/logo.png"
          alt="查验图标"
          class="w-6 h-6 mr-2"
        />
        <span>查验结果</span>
      </div>
    </template>

    <div class="modal-content px-3">
      <div v-if="checkFailed">
        <div class="text-center text-black text-base p-6">
          无此保函，请输入正确的信息！
        </div>
      </div>

      <div v-else class="grid grid-cols-1">
        <div v-for="(value, key) in formattedInfo" :key="key" class="flex items-center">
          <div class="w-1/3 text-black text-base pl-2">{{ key }}</div>
          <div class="w-2/3 text-gray-500 text-base break-words pr-2">{{ value }}</div>
        </div>
      </div>

      <div class="text-center pt-3">
        <a-button type="primary" size="large" shape="round" @click="$emit('cancel')">
          确定
        </a-button>
      </div>
    </div>
  </a-modal>
</template>

<script>
export default {
  props: {
    visible: Boolean,
    checkFailed: {
      type: Boolean,
      default: false
    },
    info: {
      type: Object,
      default: () => ({}), 
    },
  },
  data() {
    return {};
  },
  computed: {
    formattedInfo() {
      const info = { ...this.info };
      const mapping = {
        code: '保函编号',
        project: '项目名称',
        effect_month: '担保期限',
        money: '担保金额',
        bidder: '申请人',
        proprietor: '受益人',
        sign_time: '出函时间',
      };
      const result = {};
      Object.keys(mapping).forEach(key => { result[mapping[key]] = info[key]; });
      Object.keys(mapping).forEach(key => {
        if (key === 'effect_month' && info[key] !== undefined) {
          result[mapping[key]] = `${info[key]}个月`;
        }
        if (key === 'money' && info[key] !== undefined) {
          result[mapping[key]] = `￥${info[key]}`;
        }
      });
      return result;
    },
  },
  mounted() {
    
  },
  methods: {},
};
</script>

<style scoped>
.modal-content .grid {
  display: grid;
  grid-template-columns: 1fr;
}

.modal-content .flex {
  display: flex;
  align-items: center;
  padding: 12px 0;
  border-bottom: 1px solid #f0f0f0;
}

.modal-content .flex:last-child {
  border-bottom: none;
}
</style>
